jQuery(function ($) {

  // js-mv-slick
  $('.js-mv-slick').slick({
		autoplaySpeed: 5000,
		autoplay: true,
		arrows: true,
    centerMode: true,
    dots: true,
    infinite: true,
		fade: false,
		speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerPadding: '28px',
        }
      },
    ]
  });

  // js-mv-slick
  $('.js-cmn-slick01').slick({
		autoplaySpeed: 6000,
		autoplay: true,
		arrows: true,
    centerMode: true,
    centerPadding: '135px',
		fade: false,
		speed: 500,
    slidesToShow: 3,
		slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerPadding: '0',
          slidesToShow: 1,
        }
      },
    ]
  });

  // js-archive-slick01
  $('.js-archive-slick01').slick({
		autoplaySpeed: 6000,
		autoplay: true,
		arrows: false,
    centerMode: true,
    dots: true,
		fade: false,
    centerPadding: '0',
		speed: 500,
    slidesToShow: 1,
		slidesToScroll: 1,
  });

});
